import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { loginUser } from '../../reducers/StaffAuth';
import { SUBDOMAIN_KEY, ORG_CODE, APP_LOGO, APP_NAME } from '../../config/constants';
import { requestOtpApi, verifyOtpApi, resetPasswordApi, registerApi } from '../../api/auth_api';
import { ensureDashliteStyles } from '../../utils/dashlite';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Login.css';

const PUBLIC_URL = process.env.PUBLIC_URL || '';
const LOGIN_SLIDE = (filename) => `${PUBLIC_URL}/login/slides/${filename}`;

const LOGIN = 'LOGIN';
const REQUEST_OTP = 'REQUEST_OTP';
const VERIFY_OTP = 'VERIFY_OTP';
const RESET_PASSWORD = 'RESET_PASSWORD';
const REGISTER = 'REGISTER';

const SLIDES = [
  { img: LOGIN_SLIDE('iaept-community-1.jpg'), alt: `${APP_NAME} mobile app` },
  { img: LOGIN_SLIDE('iaept-community-2.jpg'), alt: `${APP_NAME} mobile app` },
  { img: LOGIN_SLIDE('iaept-community-3.jpg'), alt: `${APP_NAME} mobile app` },
];

class Login extends Component {
  state = {
    username: '',
    password: '',
    password_confirmation: '',
    mobile: '',
    subdomain: ORG_CODE,
    showPassword: false,
    otp: '',
    token: '',
    screen: LOGIN,
    errorText: '',
    FirstName: '',
    LastName: '',
    InstituteName: '',
    Email: '',
    RegisterPassword: '',
    IdCode: '',
    AppID: '',
    loading: false,
    activeSlide: 0,
    promoOpen: false,
    mobile_number: '',
  };

  sliderTimer = null;

  componentDidMount() {
    document.title = APP_NAME;
    document.body.className = 'nk-body ui-rounder npc-general ui-light pg-auth';
    localStorage.setItem(SUBDOMAIN_KEY, ORG_CODE);
    this.setState({ subdomain: ORG_CODE });
    ensureDashliteStyles();
    this.startSlider();
  }

  componentWillUnmount() {
    document.body.className = '';
    if (this.sliderTimer) {
      clearInterval(this.sliderTimer);
    }
  }

  startSlider() {
    this.sliderTimer = setInterval(() => {
      this.setState((prev) => ({
        activeSlide: (prev.activeSlide + 1) % SLIDES.length,
      }));
    }, 5000);
  }

  handleEnterPress(e) {
    if (e.key === 'Enter') {
      switch (this.state.screen) {
        case LOGIN:
          this.ValidateLogin();
          break;
        case REQUEST_OTP:
          this.requestOtp();
          break;
        case VERIFY_OTP:
          this.verifyOtp();
          break;
        case RESET_PASSWORD:
          this.resetPassword();
          break;
        default:
          break;
      }
    }
  }

  showHidePassword() {
    this.setState((prev) => ({ showPassword: !prev.showPassword }));
  }

  togglePassword = (e) => {
    e.preventDefault();
    this.showHidePassword();
  };

  togglePromo = (e) => {
    e.preventDefault();
    this.setState((prev) => ({ promoOpen: !prev.promoOpen }));
  };

  setSlide = (index) => {
    this.setState({ activeSlide: index });
  };

  requestOtp() {
    this.setState({ loading: true });
    requestOtpApi({ mobile_number: this.state.username })
      .then((data) => {
        toast.success(data.message);
        this.setState({ loading: false, screen: VERIFY_OTP, mobile_number: data.mobile_number, password: '' });
      })
      .catch((e) => {
        this.setState({ loading: false });
        if (e.data) {
          if (e.data.insufficient_sms_credits || !e.data.otp_reset_enable) {
            toast.error('OTP password reset disabled. Please contact our support team for assistance');
            return;
          }
        }
        toast.error('Unable to send OTP, check username and try again');
      });
  }

  verifyOtp() {
    this.setState({ loading: true });
    verifyOtpApi({
      mobile_number: this.state.mobile_number,
      otp: this.state.otp,
      call_func: 'generate_forgot_token',
      func_data: { email: this.state.username },
    })
      .then((res) => {
        toast.success(res.message);
        this.setState({ loading: false, token: res.token, screen: RESET_PASSWORD, otp: '' });
      })
      .catch(() => {
        toast.error('Unable to verify OTP');
        this.setState({ loading: false });
      });
  }

  doRegister() {
    this.setState({ errorText: '' });

    if (this.state.FirstName === '') {
      this.setState({ errorText: 'Enter First Name' });
      return;
    }
    if (this.state.InstituteName === '') {
      this.setState({ errorText: 'Enter Institute Name' });
      return;
    }
    if (this.state.mobile === '') {
      this.setState({ errorText: 'Enter Mobile' });
      return;
    }
    if (this.state.Email === '') {
      this.setState({ errorText: 'Enter Email' });
      return;
    }
    if (this.state.RegisterPassword === '') {
      this.setState({ errorText: 'Enter Password' });
      return;
    }

    this.setState({ loading: true });
    const organization_name = JSON.stringify({ organization_name: this.state.InstituteName });

    registerApi({
      organization_name,
      username: this.state.Email,
      password: this.state.RegisterPassword,
      password_confirmation: this.state.RegisterPassword,
      mobile: this.state.mobile,
      admin_name: `${this.state.FirstName} ${this.state.LastName}`,
      subdomain: ORG_CODE,
      first_name: this.state.FirstName,
      last_name: this.state.LastName,
      affiliate: this.state.AppID,
    })
      .then(() => {
        toast.success('Your Org. Code, Username and Password will be sent to your registered mobile number.');
        this.setState({ loading: false, screen: LOGIN });
      })
      .catch((e) => {
        toast.error(e.message);
        this.setState({ loading: false });
      });
  }

  resetPassword() {
    if (this.state.password === this.state.password_confirmation && this.state.password.length >= 8) {
      this.setState({ loading: true });
      resetPasswordApi({
        password: this.state.password,
        password_confirmation: this.state.password_confirmation,
        email: this.state.username,
        token: this.state.token,
      })
        .then(() => {
          toast.success('Password reset successfully');
          this.setState({ loading: false, screen: LOGIN });
        })
        .catch(() => {
          toast.error('Unable to Reset Password');
          this.setState({ loading: false });
        });
    } else {
      toast.error('Password and Confirm Password must be same and at least 8 characters long.');
    }
  }

  ValidateLogin(e) {
    if (e) e.preventDefault();
    this.setState({ errorText: '' });
    localStorage.setItem(SUBDOMAIN_KEY, ORG_CODE);
    this.props.loginUser({ username: this.state.username, password: this.state.password });
  }

  renderAlert() {
    const { errorText } = this.state;
    const { StaffAuth } = this.props;
    if (errorText) {
      return <div className="alert alert-danger" role="alert">{errorText}</div>;
    }
    if (StaffAuth.loginError) {
      return <div className="alert alert-danger" role="alert">Unable to login. Please check your credentials.</div>;
    }
    return null;
  }

  renderBackLink(label, screen) {
    return (
      <div className="form-group">
        <a
          href="#/"
          className="link link-primary link-sm"
          onClick={(e) => { e.preventDefault(); this.setState({ screen }); }}
        >
          {label}
        </a>
      </div>
    );
  }

  renderLogin() {
    const { username, password, showPassword } = this.state;
    const { StaffAuth } = this.props;
    const hasError = !!StaffAuth.loginError;

    return (
      <div className="nk-block nk-block-middle nk-auth-body">
        <div className="brand-logo pb-5">
          <a href="/" className="logo-link">
            <img className="logo-img logo-img-lg" src={APP_LOGO} alt={`${APP_NAME} logo`} />
          </a>
        </div>
        <div className="nk-block-head">
          <div className="nk-block-head-content">
            <h5 className="nk-block-title">Sign-In</h5>
            <div className="nk-block-des">
              <p>Sign in to access the {APP_NAME} member portal.</p>
            </div>
          </div>
        </div>
        {this.renderAlert()}
        <form className="form-validate is-alter" autoComplete="off" onSubmit={(e) => this.ValidateLogin(e)}>
          <div className="form-group">
            <label className="form-label" htmlFor="username">Username</label>
            <div className="form-control-wrap">
              <input
                autoComplete="off"
                type="text"
                className={`form-control form-control-lg${hasError ? ' is-invalid' : ''}`}
                id="username"
                placeholder="Enter Username"
                value={username}
                onChange={(e) => this.setState({ username: e.target.value })}
                onKeyDown={(e) => this.handleEnterPress(e)}
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-label-group">
              <label className="form-label" htmlFor="password">Password</label>
              <a href="#/" className="link link-primary link-sm" onClick={(e) => { e.preventDefault(); this.setState({ screen: REQUEST_OTP }); }}>
                Forgot your Password?
              </a>
            </div>
            <div className="form-control-wrap">
              <a
                href="#/"
                className={`form-icon form-icon-right passcode-switch lg${showPassword ? ' is-shown' : ''}`}
                onClick={this.togglePassword}
              >
                <em className="passcode-icon icon-show icon ni ni-eye" />
                <em className="passcode-icon icon-hide icon ni ni-eye-off" />
              </a>
              <input
                autoComplete="new-password"
                type={showPassword ? 'text' : 'password'}
                className={`form-control form-control-lg${hasError ? ' is-invalid' : ''}`}
                id="password"
                placeholder="Enter Password"
                value={password}
                onChange={(e) => this.setState({ password: e.target.value })}
                onKeyDown={(e) => this.handleEnterPress(e)}
              />
              {hasError && <div className="invalid-feedback">Unable to login</div>}
            </div>
          </div>
          <div className="form-group">
            <button
              type="submit"
              className="btn btn-lg btn-primary btn-block btn-signin"
              disabled={StaffAuth.loggingIn || StaffAuth.refreshingToken}
            >
              {StaffAuth.loggingIn ? 'Signing in...' : 'Login'}
            </button>
          </div>
        </form>
      </div>
    );
  }

  renderRequestOtp() {
    return (
      <div className="nk-block nk-block-middle nk-auth-body">
        <div className="brand-logo pb-5">
          <a href="/" className="logo-link">
            <img className="logo-img logo-img-lg" src={APP_LOGO} alt={`${APP_NAME} logo`} />
          </a>
        </div>
        <div className="nk-block-head">
          <div className="nk-block-head-content">
            <h5 className="nk-block-title">Forgot Password</h5>
            <div className="nk-block-des"><p>Enter your username to receive an OTP.</p></div>
          </div>
        </div>
        <form className="form-validate is-alter" onSubmit={(e) => { e.preventDefault(); this.requestOtp(); }}>
          <div className="form-group">
            <label className="form-label" htmlFor="otp-username">Username</label>
            <div className="form-control-wrap">
              <input
                type="text"
                className="form-control form-control-lg"
                id="otp-username"
                placeholder="Enter Username"
                value={this.state.username}
                onChange={(e) => this.setState({ username: e.target.value })}
                onKeyDown={(e) => this.handleEnterPress(e)}
              />
            </div>
          </div>
          <div className="form-group">
            <button type="submit" className="btn btn-lg btn-primary btn-block btn-signin" disabled={this.state.loading}>
              {this.state.loading ? 'Sending...' : 'Request OTP'}
            </button>
          </div>
        </form>
        {this.renderBackLink('Back To Login', LOGIN)}
      </div>
    );
  }

  renderVerifyOtp() {
    return (
      <div className="nk-block nk-block-middle nk-auth-body">
        <div className="brand-logo pb-5">
          <a href="/" className="logo-link">
            <img className="logo-img logo-img-lg" src={APP_LOGO} alt={`${APP_NAME} logo`} />
          </a>
        </div>
        <div className="nk-block-head">
          <div className="nk-block-head-content">
            <h5 className="nk-block-title">Verify OTP</h5>
          </div>
        </div>
        <form className="form-validate is-alter" onSubmit={(e) => { e.preventDefault(); this.verifyOtp(); }}>
          <div className="form-group">
            <label className="form-label" htmlFor="otp-code">OTP</label>
            <div className="form-control-wrap">
              <input
                type="text"
                className="form-control form-control-lg"
                id="otp-code"
                placeholder="Enter OTP"
                value={this.state.otp}
                onChange={(e) => this.setState({ otp: e.target.value })}
                onKeyDown={(e) => this.handleEnterPress(e)}
              />
            </div>
          </div>
          <div className="form-group">
            <button type="submit" className="btn btn-lg btn-primary btn-block btn-signin" disabled={this.state.loading}>
              {this.state.loading ? 'Verifying...' : 'Verify OTP'}
            </button>
          </div>
        </form>
        {this.renderBackLink('Back', REQUEST_OTP)}
      </div>
    );
  }

  renderResetPassword() {
    return (
      <div className="nk-block nk-block-middle nk-auth-body">
        <div className="brand-logo pb-5">
          <a href="/" className="logo-link">
            <img className="logo-img logo-img-lg" src={APP_LOGO} alt={`${APP_NAME} logo`} />
          </a>
        </div>
        <div className="nk-block-head">
          <div className="nk-block-head-content">
            <h5 className="nk-block-title">Change Password</h5>
          </div>
        </div>
        <form className="form-validate is-alter" onSubmit={(e) => { e.preventDefault(); this.resetPassword(); }}>
          <div className="form-group">
            <label className="form-label" htmlFor="new-password">Password</label>
            <div className="form-control-wrap">
              <input
                type="password"
                className="form-control form-control-lg"
                id="new-password"
                placeholder="Enter Password"
                value={this.state.password}
                onChange={(e) => this.setState({ password: e.target.value })}
                onKeyDown={(e) => this.handleEnterPress(e)}
              />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="confirm-password">Confirm Password</label>
            <div className="form-control-wrap">
              <input
                type="password"
                className="form-control form-control-lg"
                id="confirm-password"
                placeholder="Re-Enter Password"
                value={this.state.password_confirmation}
                onChange={(e) => this.setState({ password_confirmation: e.target.value })}
                onKeyDown={(e) => this.handleEnterPress(e)}
              />
            </div>
          </div>
          <div className="form-group">
            <button type="submit" className="btn btn-lg btn-primary btn-block btn-signin" disabled={this.state.loading}>
              {this.state.loading ? 'Resetting...' : 'Reset Password'}
            </button>
          </div>
        </form>
        {this.renderBackLink('Back', REQUEST_OTP)}
      </div>
    );
  }

  MakeIdntificationCode(e) {
    let str = e.target.value;
    str = str.replace(/ /g, '');
    str = str.replace(/[^0-9a-zA-Z ]/g, '');
    this.setState({ FirstName: str });
    const IDCode = str.substring(0, 3);
    const Mobile = this.state.mobile.slice(-3);
    this.setState({ IdCode: `Identification Code : ${IDCode}${Mobile}` });
  }

  setMobile(e) {
    let str = e.target.value;
    str = str.replace(/[^0-9]/g, '');
    this.setState({ mobile: str });
    const IDCode = this.state.FirstName.substring(0, 3);
    const Mobile = e.target.value.slice(-3);
    this.setState({ IdCode: `Identification Code : ${IDCode}${Mobile}` });
  }

  renderRegister() {
    return (
      <div className="nk-block nk-block-middle nk-auth-body">
        <div className="brand-logo pb-5">
          <a href="/" className="logo-link">
            <img className="logo-img logo-img-lg" src={APP_LOGO} alt={`${APP_NAME} logo`} />
          </a>
        </div>
        <div className="nk-block-head">
          <div className="nk-block-head-content">
            <h5 className="nk-block-title">Sign Up</h5>
          </div>
        </div>
        {this.renderAlert()}
        <form className="form-validate is-alter" onSubmit={(e) => { e.preventDefault(); this.doRegister(); }}>
          <div className="form-group">
            <input className="form-control form-control-lg" placeholder="First Name" value={this.state.FirstName} onChange={(e) => this.MakeIdntificationCode(e)} />
            <div className="form-hint text-danger">Special characters and space are not allowed</div>
          </div>
          <div className="form-group">
            <input
              className="form-control form-control-lg"
              placeholder="Last Name"
              value={this.state.LastName}
              onChange={(e) => {
                let str = e.target.value.replace(/ /g, '').replace(/[^0-9a-zA-Z ]/g, '');
                this.setState({ LastName: str });
              }}
            />
            <div className="form-hint text-danger">Special characters and space are not allowed</div>
          </div>
          <div className="form-group">
            <input className="form-control form-control-lg" maxLength={10} placeholder="Mobile" value={this.state.mobile} onChange={(e) => this.setMobile(e)} />
          </div>
          <div className="form-group">
            <input
              className="form-control form-control-lg"
              placeholder="Institute's Name"
              value={this.state.InstituteName}
              onChange={(e) => {
                const str = e.target.value.replace(/[^0-9a-zA-Z ]/g, '');
                this.setState({ InstituteName: str });
              }}
            />
            <div className="form-hint text-danger">Special characters and space are not allowed</div>
          </div>
          <div className="form-group">
            <input className="form-control form-control-lg" placeholder="Email" value={this.state.Email} onChange={(e) => this.setState({ Email: e.target.value })} />
          </div>
          <div className="form-group">
            <input className="form-control form-control-lg" placeholder="Password" value={this.state.RegisterPassword} onChange={(e) => this.setState({ RegisterPassword: e.target.value })} />
          </div>
          <div className="form-group">
            <input className="form-control form-control-lg" placeholder="Identification Code" readOnly value={this.state.IdCode} />
          </div>
          <div className="form-group">
            <input className="form-control form-control-lg" placeholder="App ID" value={this.state.AppID} onChange={(e) => this.setState({ AppID: e.target.value })} />
          </div>
          <div className="form-group">
            <button type="submit" className="btn btn-lg btn-primary btn-block btn-signin" disabled={this.state.loading}>
              {this.state.loading ? 'Registering...' : 'Register'}
            </button>
          </div>
        </form>
        {this.renderBackLink('Back To Login', LOGIN)}
      </div>
    );
  }

  renderAuthContent() {
    switch (this.state.screen) {
      case LOGIN: return this.renderLogin();
      case REQUEST_OTP: return this.renderRequestOtp();
      case VERIFY_OTP: return this.renderVerifyOtp();
      case RESET_PASSWORD: return this.renderResetPassword();
      case REGISTER: return this.renderRegister();
      default: return this.renderLogin();
    }
  }

  renderPromoSlider() {
    const { activeSlide } = this.state;
    return (
      <div className="slider-wrap w-100 p-3 p-sm-5 m-auto login-slider">
        <div className="slider-init">
          {SLIDES.map((slide, index) => (
            <div key={slide.img} className={`slider-item${index === activeSlide ? ' active' : ''}`}>
              <div className="nk-feature nk-feature-center">
                <div className="nk-feature-img">
                  <img className="round login-slide-image" src={slide.img} alt={slide.alt} />
                </div>
              </div>
            </div>
          ))}
        </div>
        <ul className="slick-dots">
          {SLIDES.map((slide, index) => (
            <li key={slide.img} className={index === activeSlide ? 'slick-active' : ''}>
              <button type="button" onClick={() => this.setSlide(index)}>{index + 1}</button>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  render() {
    const { promoOpen } = this.state;
    const { StaffAuth } = this.props;

    if (StaffAuth.refreshingToken) {
      return (
        <div className="login-page-root">
          <div className="nk-app-root">
            <div className="nk-main">
              <div className="nk-wrap nk-wrap-nosidebar">
                <div className="nk-content">
                  <div className="nk-split nk-split-page nk-split-lg">
                    <div className="nk-split-content nk-block-area nk-block-area-column nk-auth-container bg-white w-100">
                      <div className="nk-block nk-block-middle nk-auth-body text-center">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <Fragment>
        <div className="login-page-root">
          <div className="nk-app-root">
            <div className="nk-main">
              <div className="nk-wrap nk-wrap-nosidebar">
                <div className="nk-content">
                  <div className="nk-split nk-split-page nk-split-lg">
                    <div className="nk-split-content nk-block-area nk-block-area-column nk-auth-container bg-white">
                      <div className="absolute-top-right d-lg-none p-3 p-sm-5">
                        <a href="#/" className="toggle btn-white btn btn-icon btn-light" onClick={this.togglePromo}>
                          <em className="icon ni ni-info" />
                        </a>
                      </div>
                      {this.renderAuthContent()}
                    </div>
                    <div className={`nk-split-content nk-split-stretch bg-lighter d-flex toggle-break-lg toggle-slide toggle-slide-right login-promo-panel${promoOpen ? ' open' : ''}`}>
                      {this.renderPromoSlider()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProp = state => ({
  StaffAuth: state.StaffAuth,
});

const mapDispatchToProps = dispatch => ({
  loginUser: (payload) => loginUser(dispatch, payload),
});

export default connect(mapStateToProp, mapDispatchToProps)(Login);
